// WERKWAAR SHOPIFY THEME — JavaScript
// Minimal, no dependencies

document.addEventListener('DOMContentLoaded', function() {
  // Smooth scroll voor ankerliks
  document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
});
